<template>
  <div>
    <div class="flex flex-right align-items-center mb8">
      <div class=""></div>
       <a-button  v-if="type=='分社'" style="margin-right: 20px" type="primary" @click="gosh"
        >一键审核</a-button
      >
      <a-upload
        :before-upload="beforeUpload"
        accept=".xls,.xlsx"
        :showUploadList="false"
      >
      <!-- v-if="$store.state.region!='5'" -->
      <a-button style="margin-right: 20px"  type="primary">导入</a-button>
      </a-upload>
      <a-button style="margin-right: 20px" type="primary" @click="exportFile"
        >导出</a-button
      >
      <a-button class="add-btn" @click="addPage(type)">
        新增{{ type === "" ? "" : type }}
      </a-button>
    </div>
    <div>
      <a-table
        style="text-align: center"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="true"
        rowKey="id"
        :locale="{ emptyText: '暂无数据' }"
        :rowSelection="rowSelectionCfg"
        :scroll="scroll"
      >
        <span slot="username" slot-scope="text">
          <div class="username" :title="text">{{ text }}</div>
        </span>
        <span slot="realname" slot-scope="text">
          <div class="realname" :title="text">{{ text }}</div>
        </span>
        <!-- 学校管理：所属分社（后端字段名不固定，这里做兼容回显） -->
        <span slot="branch" slot-scope="text, record">
          <div class="realname" :title="branchText(record)">{{ branchText(record) }}</div>
        </span>
         <span slot="status" slot-scope="text">
          <span  v-if="text=='正常'" style="color:#38ce44;"  :title="text">{{ text }}</span>
          <span  v-else   style="color:#b25d24;" :title="text">{{ text }}</span>
        </span>
        <!-- 学校管理：学校类型（字典翻译优先，未配置字典时回显原值） -->
        <span slot="schoolType" slot-scope="text, record">
          <div class="realname" :title="text || record.schoolType || '-'">{{ text || record.schoolType || '-' }}</div>
        </span>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 40px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>删除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="resetPasswords(record)"
          >
            <img
              class="img-box-reset"
              src="../../assets/images/img52.png"
              alt=""
            />
            <span>初始密码</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要一键审核通过吗?</p>
    </a-modal>
  </div>
</template>

<script>
import { userLxExport, userLxImport,postAction} from "@/api/index"; //
const columns = [
  {
    title: "工作室名称",
    dataIndex: "name",
    id: "name",
    align: "center",
  },
  {
    title: "项目负责人",
    dataIndex: "principals",
    id: "principals",
    align: "center",
  },
  {
    title: "联系电话",
    dataIndex: "phone",
    id: "phone",
    align: "center",
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 354,
    scopedSlots: { customRender: "action" },
  },
];

const data = [];
export default {
  name: "",
  components: {},
  props: {
    columns: {
      type: Array,
      default: () => columns,
    },
    loading: Boolean,
    data: {
      type: Array,
      default: () => data,
    },
    type: {
      type: String,
      default: "",
    },
    pagination: {
      type: Object,
    },
    scroll: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedRowKeys: [],
      showDeleteModel:false,
    };
  },
  computed: {
    // 列表类型 -> 角色编码：分社 school-role / 学校 draw-role / 专家 expert-role
    roleCode() {
      const map = {
        分社: "school-role",
        学校: "draw-role",
        专家: "expert-role",
      };
      return map[this.type] || "expert-role";
    },
    // 只有分社管理需要勾选（一键审核），学校/专家管理不显示多选列
    rowSelectionCfg() {
      if (this.type !== "分社") return null;
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.handleSelectionChange,
        getCheckboxProps: this.getCheckboxProps,
      };
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 所属分社展示：兼容后端不同返回字段
    branchText(record) {
      if (!record) return "-";
      return (
        record.branchName ||
        record.parentName ||
        record.provincecode_dictText ||
        record.branchId_dictText ||
        "-"
      );
    },
    addPage(type) {
      // (this.$store.state.region!='5' && type!='分社') ||
    	if(  (this.$store.state.region=='5' && (type=='专家' || type=='分社' || type=='学校'))){
    		 this.$emit("showAddPop", type);
    	}
    },
    handleSelectionChange(val) {
      this.selectedRowKeys = val;
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.status!='0'
        }
      };
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.$emit("getLxApplyApplylist", this.pagination);
    },
    deleteInfo(row) {
      this.$emit("deleteApply", row.id);
    },
    editInfo(row) {
      this.$emit("editInfo", row);
    },
    resetPasswords(row) {
      this.$emit("resetPasswords", row);
    },
    exportFile() {
      let params = {
        roleCode: this.roleCode,
      };
      userLxExport(params).then((res) => {
        let url = window.URL.createObjectURL(
          new Blob([res], { type: "application/vnd.ms-excel" })
        );
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute(
          "download",
          `${this.type}账户` + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
      });
    },
    gosh(){
       if(this.selectedRowKeys.length=='0'){
        this.$message.error('请先选择待审核的用户');
        return false;
      }
      this.showDeleteModel=true;
    },
    handleOk(){
       let params={};
       params.ids=this.selectedRowKeys.join();
        postAction('/sys/user/auditUser',params).then((res) => {
              if(res.code=='200'){
                this.$message.success(res.message);
                setTimeout(() => {
                  this.showDeleteModel = false;
                  this.selectedRowKeys=[];
                  this.pagination.current =1;
                  this.$emit("getLxApplyApplylist", this.pagination);
                }, 2000);
              }else{
                this.$message.error(res.message);
              }
        });
    },
    beforeUpload(file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("roleCode", this.roleCode);
      userLxImport(formData).then((res) => {
        if (res.code === 200) {
          this.$emit("getLxApplyApplylist", this.pagination);
        } else {
          this.$message.warning(res.message);
        }
      });
      // this.fileList = [...this.fileList, file];
      // return false;
    },
  },
};
</script>

<style scoped lang="scss">
.header-time-box {
  width: 363px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: #b7d1ff;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #9A0B00;
  border-radius: 10px;
}
.add-btn {
  text-align: center;
  background: #9A0B00;
  border: 1px solid #9A0B00;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.mb8 {
  margin-bottom: 8px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-reset {
  width: 22px;
  height: 22px;
  margin-right: 9px;
}
.table-box {
  text-align: center;
}
.username {
  width: 150px;
  margin: 0 auto;
  text-align: center;
}
.realname {
  // width: 200px;
  margin: 0 auto;
  text-align: center;
}
</style>
